export default __webpack_public_path__ + "static/media/frog_R2_C6.d3f1bab4.png";